import React from 'react';
import './SchoolHours.css';
import { useEffect } from 'react';
function SchoolHours() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);
      
  return (
    <div className="school-hours-container">
      <div className="school-hours-section">
        <h2 className="school-hours-heading">School Hours</h2>
        <p className="school-hours-paragraph">
          <strong>The Academic Year Comprises Two Terms:</strong>
          <br />
          The First Term from June to October and The Second Term from November to April.
        </p>

        <p className="school-hours-paragraph">
          <strong>The School gives three long holidays during the year:</strong>
          <br />
          End of 1st Term vacation: About 2 weeks
          <br />
          Christmas vacation: About 2 weeks
          <br />
          Summer vacation: About 6 weeks
        </p>

        <p className="school-hours-paragraph">
          The dates of opening and closing of school must be strictly observed. If a child leaves early at the end of the term, their report will be withheld until the following term.
          Parents are informed and are especially asked to note that, in the interest of their children and the discipline of the school, it is absolutely imperative that they strictly abide by the
          opening and closing dates of the school. On no account can “Special Cases” be considered for permission to break the rule. No child will leave school before the beginning of a holiday
          (Diwali, Christmas & Summer vacations) and absolute punctuality is necessary on the re-opening of the school. Students not returning to school within a month after the holidays are liable
          to have their names struck off the rolls. If a child has to leave early or return late due to certain unavoidable circumstances, the Principal must be intimated in writing.
        </p>

        <h3 className="school-hours-subheading">School Timings: (Monday to Friday)</h3>
        <ul className="school-hours-list">
          <li>Pre-Nursery, Nursery, and Prep: 08.30 a.m. to 02.30 p.m.</li>
          <li>Std. I to VIII: 08.30 a.m. to 02.30 p.m.</li>
        </ul>

        <p className="school-hours-paragraph">
          Pupils are asked to arrive at school 15 minutes before school starts. All members of staff are on duty for 15 minutes before and after school. Please make sure your child arrives on time.
          This is very important because good habits need to be established early and we want all children to start the day well. Parents are requested to fetch their children on time. We are not
          legally responsible for your children before or after the pre-stipulated times.
        </p>
      </div>
    </div>
  );
}

export default SchoolHours;
